class DropDown extends HTMLElement {
  constructor() {
    super();
    this.dropDownFunction = this.dropDownFunction.bind(this);
    this.sameToggle = this.getAttribute('sameToggle');
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  dropDownFunction() {
    this.dropdown = this.querySelector('.dropdown');
    this.dropdownButton = this.querySelector('#dropdown-button');
    this.dropdownMenu = this.querySelector('.dropdown-menu');

    if (this.dropdown && this.dropdownButton && this.dropdownMenu) {
      this.dropdownButton.addEventListener("click", () => {
        this.toggleDropdown();
      })

      document.addEventListener("click", this.handleClickOutside);
    }
  }

  toggleDropdown() {
    const sameDropDowns = document.querySelectorAll(`[sameToggle=${this.sameToggle}]`);
    const isOpen = this.dropdown.classList.toggle("open");
    this.dropdown.setAttribute('data-open', isOpen);

    if (sameDropDowns.length) {
      sameDropDowns.forEach(dropDown => {
        if (dropDown.sameToggle === this.sameToggle && dropDown !== this) {
            dropDown.dropdown.classList.remove("open");
        }
      });
    }
    const label= document.querySelector('.subject__field-input');
    if (isOpen){
      label.classList.add('subject__field-open')
    }else{
      label.classList.remove('subject__field-open')
    }
  }

  handleClickOutside(event) {
    if (!this.contains(event.target)) {
      this.dropdown.classList.remove("open");
      this.dropdown.setAttribute('data-open',false);
    }
  }

  connectedCallback() {
    this.dropDownFunction();
  }

  disconnectedCallback() {
    if (this.dropdownButton) {
      this.dropdownButton.removeEventListener("click", this.toggleDropdown);
    }
    document.removeEventListener("click", this.handleClickOutside);
  }
}

const init = () => {
  if (!customElements.get("custom-dropdown")) {
    customElements.define('custom-dropdown', DropDown);
  }
};

init();

export default DropDown;
